import React, { useEffect, useState, useRef, useCallback } from "react";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import HeaderPages from "app/pages/components/HeaderPages";
import { Grid } from "@mui/material";
import ProcessDetailsHeader from "app/pages/components/ProcessDetailsHeader";
import ProcessDispatches from "app/pages/components/ProcessDispatches";
import moment from "moment";
import "moment/locale/pt";
import DateRangeIcon from "@mui/icons-material/DateRange";
import PersonIcon from "@mui/icons-material/Person";
import ProcessMovements from "app/pages/components/ProcessMovements";
import { useParams } from "react-router-dom";
import { useAPI } from "app/hooks/useApi";
import Loading from "app/pages/components/Loading";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";

moment.locale("pt");

const DetalhesProcesso = () => {
  const { authUser } = useJumboAuth();
  const [processo, setProcesso] = useState({});
  const [cabecalhosProcesso, setCabecalhosProcesso] = useState([]);
  const { makeRequest, loading } = useAPI();
  const { id } = useParams();
  const fetchProcessoRef = useRef(false);
  
  const fetchProcesso = useCallback(async () => {
    if (!id || fetchProcessoRef.current) return;
    
    fetchProcessoRef.current = true;
    try {

      const response = await makeRequest(`processos-revistas-rpi/${id}`, "GET");
      
      if (response.status === 200) {
        setProcesso(response.data);

      }
    } catch (error) {

    }
  }, [id, makeRequest]);

  useEffect(() => {
    fetchProcesso();
  }, [fetchProcesso]); // Agora inclui fetchProcesso para garantir atualizações

  useEffect(() => {
    if (!processo) return;
    if (processo) {
      setCabecalhosProcesso([
        {
          title: "Número do processo",
          subtitle: processo?.numero || "- - -",
          icon: null,
        },
        {
          title: "Data de depósito",
          subtitle: processo?.data_deposito 
            ? moment(processo.data_deposito).format("DD [de] MMMM [de] YYYY")
            : "- - -",
          icon: <DateRangeIcon />,
        },
        {
          title: "Titular/Envolvido",
          subtitle: processo?.titulares?.length > 0 
            ? processo.titulares[0].nome_razao_social 
            : "- - -",
          icon: <PersonIcon />,
        },
      ]);
    }
  }, [processo]);

  return (
    <JumboContentLayout
      header={
        <HeaderPages
          title={"Detalhes do processo"}
          hasButton={true}
          isBackButton={true}
        />
      }
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          <Grid container width="100%" spacing={2}>
            <Grid item xs={8}>
              <ProcessDetailsHeader
                data={cabecalhosProcesso}
                data_deposito={processo?.data_deposito}
                data_concessao={processo?.data_concessao}
                data_vigencia={processo?.data_vigencia}
                data_publicacao={processo?.data_publicacao}
                data_deferimento={processo?.data_deferimento}
                data_prorrogacao={processo?.data_prorrogacao}
                despachos={processo?.despachos}
              />
            </Grid>
            <Grid item xs={4}>
              <ProcessMovements process={processo} />
            </Grid>
          </Grid>
          <Grid container width="100%" spacing={2} my={1}>
            <Grid item xs={12}>
              <ProcessDispatches dispatches={processo?.despachos} />
            </Grid>
          </Grid>
        </>
      )}
    </JumboContentLayout>
  );
};

export default DetalhesProcesso;
